import React, { useEffect, useState } from 'react';

function RecruitFooter() {
    return(
    <div id="footer">
        <div className="bg">
            <strong className="logo"><img src="https://recruit.sbs.co.kr:994/common/images/common/logo_footer2.png" alt="SOLUTIONS BY 등용문"/></strong>
            <ul>
                <li className="first"><a href="https://recruit.sbs.co.kr:994/document/privacy_process" id="privacy_process" title="개인정보처리방침 새창열림" target="_blank"><strong>개인정보처리방침</strong></a></li>
                <li><a href="https://recruit.sbs.co.kr:994/document/email_process" id="email_process" title="이메일주소 무단수집거부 새창열림" target="_blank">이메일주소 무단수집거부</a></li>            
            </ul>
            <p className="txt1">© SaraminHR Co.,Ltd.</p>
        </div>
    </div>);
}

export default RecruitFooter;